<template>
  <li class="dropdown notification-list topbar-dropdown">
    <a
        aria-expanded="false"
        aria-haspopup="false"
        class="nav-link dropdown-toggle waves-effect waves-light"
        data-toggle="dropdown"
        href="#"
        role="button"
    >
      <i class="fe-bell noti-icon"/>
      <span v-cloak :class="labelNumberNotification" class="badge rounded-circle noti-icon-badge">
        {{ unreadNotifCount }}
      </span>
    </a>
    <div class="dropdown-menu dropdown-menu-right dropdown-lg">
      <template v-if="unreadNotifCount > 0">
        <!-- item-->
        <div class="dropdown-item noti-title">
          <h5 class="m-0">
						<span class="float-right">
							<a
                  class="text-dark"
                  href="javascript:void(0)"
                  @click="marksAllAsRead()"
              >
								<small>Limpar</small>
							</a>
						</span>
            Notificações
          </h5>
        </div>

        <div class="noti-scroll">
          <a
              v-for="(notification, index) in unreadNotifications"
              :key="notification.id"
              :class="[index === 0 ? 'active' : '']"
              class="dropdown-item notify-item"
              href="javascript:void(0);"
              @click="markAsRead(notification)"
          >
            <div class="notify-icon">
              <img
                  :alt="notification.senderName"
                  :src="notification.imageSender"
                  class="img-fluid rounded-circle"
                  @error="imgUrlAlt"
              >
            </div>
            <p class="notify-details">
              {{ notification.senderName }}
            </p>
            <p class="text-muted mb-0 user-msg">
              <small>
                {{ notification.message }}
              </small>
              <br>
              <small class="text-muted">
                <i class="mdi mdi-clock"/>
                {{ notification.previewCreated }}
              </small>
            </p>
          </a>
        </div>

        <!-- All-->
        <a
            class="dropdown-item text-center text-primary notify-item notify-all"
            href="javascript:void(0);"
            @click="marksAllAsRead()"
        >
          Limpar todas
          <i class="fe-check"/>
        </a>
      </template>
      <template v-else>
        <div class="dropdown-item noti-title">
          <h5 class="m-0">
            Sem notificações no momento
          </h5>
        </div>
      </template>
    </div>
  </li>
</template>

<script>
export default {
  name: "Notification",
  data() {
    return {
      unreadNotifCount: 0,
      unreadNotifications: [],
      showModal: false,
      showPreviewNotification: [],
    }
  },
  computed: {
    labelNumberNotification() {
      if (this.unreadNotifCount > 0) {
        return 'badge-danger'
      } else {
        return 'badge-success'
      }
    }
  },
  mounted() {
    this.notifyCount();
    //this.notifications()
  },
  methods: {
    markAsRead: function (notification) {
      //console.log(notification)
      this.$axios.get(route('api.notification.markAsRead', notification.id)).then(() => {
        this.unreadNotifCount = 0;
        this.unreadNotifications = [];
        this.notifyCount();
        this.notifications();
        // this.showModal = true;
        // this.openDrop();

        if (notification.hasOwnProperty('url')) {
          window.location.href = notification.url;
        }
      }).catch(error => {
        console.error(error)
      });
    },
    notifyCount: function () {
      this.$axios.get(route('api.notification.countUnread')).then((response) => {
        this.unreadNotifCount = response.data;

        if (this.unreadNotifCount > 0) {
          this.notifications();
        }

      }).catch(error => {
        console.error(error)
      });
    },
    notifications: function () {
      axios.get(route('api.notification.unread')).then(response => (
          this.unreadNotifications = response.data
      )).catch(error => {
        console.error(error)
      });
    },

    preview: function (id) {
      this.$axios.get(route('api.notification.show', id)).then(response => {
        this.showPreviewNotification = response.data;
      }).catch(error => {
        console.log(error)
      });
    },
    marksAllAsRead() {
      this.$axios.post(route('api.notification.markAllRead')).then(() => {
        this.unreadNotifCount = 0;
        this.unreadNotifications = [];
        // this.notifyCount();
        // this.notifications();
        this.showModal = true;
        // this.openDrop();
      }).catch(error => {
        console.log(error)
      });
    },
    openDrop() {
      this.showModal = !this.showModal;

      if (this.showModal) {
        $('.messages-menu').addClass('open');
      } else {
        $('.messages-menu').removeClass('open');
      }
    }
  }
}
</script>

<style scoped>
.slimScrollDiv {
  max-height: 300px;
  overflow-y: scroll;
}
</style>
